import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { SectionHeading } from '../components/SectionHeading';
import { Reveal } from '../components/Reveal';
import { portfolio } from '../data/content';

export const PortfolioTeaser = () => (
  <section data-testid="portfolio-teaser-section" className="bg-paper">
    <div className="mx-auto max-w-7xl px-5 py-20 sm:px-8 sm:py-28">
      <div className="flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
        <SectionHeading
          chapter="07"
          eyebrow="Portfolio & Case Studies"
          title="Creative Work. Strategic Thinking. Real Projects."
          copy="A look at the kind of work we craft across marketing, branding, web, content, and training."
        />
        <Reveal delay={0.2}>
          <Link to="/portfolio" data-testid="portfolio-view-all" className="btn-outline-dark shrink-0">
            View Full Portfolio <ArrowUpRight size={16} />
          </Link>
        </Reveal>
      </div>
      <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {portfolio.slice(0, 4).map((p, i) => (
          <Reveal key={p.id} delay={(i % 4) * 0.08} className={i === 0 ? 'sm:col-span-2 lg:row-span-2' : ''}>
            <Link
              to="/portfolio"
              data-testid={`portfolio-teaser-${p.id}`}
              className="group relative block h-full overflow-hidden rounded-2xl"
            >
              <div className={`img-frame h-full ${i === 0 ? 'aspect-[4/3] lg:aspect-auto lg:h-full' : 'aspect-[4/3]'}`}>
                <img src={p.image} alt={p.imageAlt} loading="lazy" />
              </div>
              <div className="absolute inset-0 flex flex-col justify-end bg-gradient-to-t from-ink/85 via-ink/20 to-transparent p-6 opacity-95 transition-opacity duration-500">
                <span className="mb-2 w-fit rounded-full bg-forest px-3 py-1 font-mono text-[10px] uppercase tracking-[0.18em] text-white">
                  {p.category}
                </span>
                <h3 className="font-display text-xl font-bold text-white">{p.title}</h3>
                <p className="mt-1 text-xs text-white">{p.service}</p>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
